/** @internal */
export const SIZE = 5

/** @internal */
export const BUCKET_SIZE = Math.pow(2, SIZE)

/** @internal */
export const MASK = BUCKET_SIZE - 1

/** @internal */
export const MAX_INDEX_NODE = BUCKET_SIZE / 2

/** @internal */
export const MIN_ARRAY_NODE = BUCKET_SIZE / 4
